import styles from "./ProfilePageContainer.module.scss";

export function ProfilePageContainer(props) {
  return <div {...props} className={styles.profilePageContainer} />;
}
